// extracted by mini-css-extract-plugin
export default {"container":"Xaa-z","oos":"Yaa-z","oosUx":"Zaa-z","selected":"_aa-z","labelOos":"aba-z"};